<template>
  <div>
    <van-sticky :z-index="1000">
      <div class="head-box">
        <div class="notice-bar" v-if="personalData.waitRefundNum > 0">
          <div class="left">
            <van-icon class="volume" name="volume" />
            <div class="content">退款待处理订单播报</div>
          </div>
          <div class="right" @click="to('/customer-list')">去处理</div>
        </div>
        <van-tabs v-model="currentCmp" title-active-color="#FF6B31">
          <van-tab 
            :title="item.label"
            :name="item.value"
            v-for="(item,index) in oneTable" :key="index" 
          />
        </van-tabs> 
        <div class="two-table" v-if="currentCmp == 'activityLook'">
          <div 
            class="table-item" 
            v-for="item in twoTable" :key="item.value"
            :class="{'active': status === item.value}"
            @click="changeStatus(item.value)"

          >{{ item.label }}</div>
        </div>
        <div class="border"></div>
      </div>
    </van-sticky>
    <div class="content-box">
      <component :is="currentCmp" :active="status" ref="dataLookRef"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import activityLook from './activity-look.vue'
import dataLook from './data-look.vue'
import withdrawCash from './withdraw-cash.vue'
import operationManual from './operation-manual.vue'

export default {
  name: 'TableHead',
  model: {
    prop: 'active',
    event: 'input'
  },
  components: {
    activityLook,
    dataLook,
    withdrawCash,
    operationManual
  },
  data() {
    return {
      oneTable: [
        { label: '活动查看', value: 'activityLook'},
        { label: '数据查看', value: 'dataLook'},
        { label: '提现', value: 'withdrawCash'},
        { label: '操作手册', value: 'operationManual'}
      ],
      twoTable: [
        { label: '待开始', value: 1 }, 
        { label: '进行中', value: 2 }, 
        { label: '已结束', value: 3 }, 
        { label: '草稿箱', value: 0 }
      ],
      status: 2,
      currentCmp: 'activityLook',
      personalData: {},

    }
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo'
    ]),
  },
  mounted() {
    this.getActivitySignupData()
    if (this.isGuide) {
      this.twoTable.splice(3,1)
    }
  },
  methods: {
    getActivitySignupData() {
      this.$api.h5.getActivitySignupData({})
        .then(res => {
          this.personalData = res.data
        })
    },
    changeStatus(status) {
      this.status = status;
      this.$refs.dataLookRef.handleChange(this.status);
    },
    to(path) {
      this.$router.push({
        path: path,
        query: {state: 5}
      })
      
    },
  }
}
</script>

<style scoped lang="stylus">
.head-box {
  position: relative;
  background: #fff;
  padding: 8px 14px 20px 14px;
  .notice-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    background: linear-gradient( 90deg, #FF8231 0%, #FF6B59 100%);
    padding: 0 10px;
    border-radius: 6px;
    .left {
      display: flex;
      align-items: center;
      .volume {
        font-size: 16px;
        color: #fff;
        margin-right: 12px;
      }
      .content {
        color: #FFFFFF;
        font-size: 15px;
      }
    }
    .right {
      width: 64px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      color: #FF6B31;
      font-size: 14px;
      background: #FFFFFF;
      border-radius: 12px;
    }
  }
  /deep/ .van-tabs__nav--line {
    padding-bottom: 10px;
  }
  /deep/ .van-tabs .van-tabs__line {
    height: 3px;
    background: #FF6B31;
  }
  .two-table {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    .table-item {
      width: 80px;
      height: 26px;
      font-size: 14px;
      color: #999999;
      text-align: center;
      line-height: 26px;
      background: #F4F4F4;
      border-radius: 12px;
    }
    .active {
      color: #FF6B31;
      background: #FFF2ED;
    }

  }
  .border {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: #F4F4F4;
  }

}
.content-box {
  padding: 0 12px;
  background: #F4F4F4;

}
</style>
